import React from "react";

export default ({...props}) => {
	return (
		<span className="modal-close" {...props} />
	);
};
